import getQuery from './query';

/**
 * Custom Events FaceBook
 *
 * @returns {void}
 */
const fbCustomEvents = () => {
    if (typeof window.fbq !== 'function') return;

    const path = location.pathname;
    const search = location.search;
    const referrer = document.referrer;

    const query = getQuery(search);

    const pattern = new RegExp(/\/test/g);
    const notSuccess = !('send' in query && query['send'] === 'success');

    if (pattern.test(path) && referrer && notSuccess) {
        window.fbq('trackCustom', 'FilledInitialForm', {query: search, referrer: referrer});
        console.log('fbq - FilledInitialForm');
    }
};

export default fbCustomEvents;
